export enum DDQStatus {
  pending = 'PENDING',
  open = 'OPEN', // DISTRIBUTOR TO ACTION: when published to distributor for completion
  issuer = 'ISSUER', // ISSUER TO ACTION: when published to issuer for completion
  draft = 'DRAFT', // INSPIRE TO ACTION: when issuer or distributor release back to inspire for drafting
  requestSignoff = 'REQUESTSIGNOFF', // DISTRIBUTOR TO ACTION: when asking distributor to sign off
  requestIssuerSignoff = 'REQUESTISSUERSIGNOFF', // ISSUER TO ACTION: when asking issuer to sign off
  signed = 'SIGNED',
  issuerSigned = 'ISSUERSIGNED', // MDA signed by issuer, similar to issued status for KYD
  issued = 'ISSUED',
  completed = 'COMPLETED',
  chase = 'CHASE',
  onhold = 'ONHOLD',
  inspire = 'INSPIRE',
}

export const ISSUER_SIG_SECTION_IDS = [
  '29d5c74e-34bb-4a49-a471-db496ba82022',
  '96e3ab27-413a-43ab-943d-f3bf08758554',
  'bf009959-315c-44ce-b10e-0d492ce34455',
  '8712e27b-e14b-436f-8754-d984d76d6e18',
];
export const DISTRIBUTOR_SIG_SECTION_IDS = [
  '43a7456d-0903-4bd9-8a1e-1000d3be8290',
  'ef483bc6-5149-47fc-a5cd-8fbdd90a1176',
  '74de66e3-0cb7-4242-97cf-be4dc19ce78b',
  'd2199d88-1d29-4a18-99c6-38c0bb5da29e',
  '3ad7bdaf-17b4-41d4-bd8a-e55dcfa674a4',
]; // more ids will be added if we have more mda templates other than MS
